import { createRouter, createWebHashHistory } from 'vue-router'

/**
 * 
 *  固定路由
*/
export const constantRoutes = [
    {
        path: '/',
        redirect: '/auth',  // 重定向到登录页
        hidden: true
    },
    {
        name: 'Login',
        path: '/auth',
        hidden: true,
        component: () => import('@/views/login/index'),
        meta: {
            title: 'login'
        }
    },
    {
        name: 'Home',
        path: '/home',
        hidden: true,
        component: () => import('@/views/home/index'),
        meta: {
            title: 'login home'
        }
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes: constantRoutes
})

export default router